import React, {useEffect, useState} from 'react';
import {Row, Button, Col} from 'react-bootstrap';
import styles from './work-bank-details.module.scss';
import {
  DropDown,
  FormGroup,
  RadioButton,
  TextInput
} from "../../../../../components/form/form";
import {useValidation} from "../../../../../hooks/use-validation";
import {getSettBankList} from "../../../../../helpr/orderFormData";
import {getGenericSalutationTypes} from "../../../../../helpr/genericFormData";
import {getTaxStatusTypes} from "../../../../../helpr/transferFormData";
import {
  workBankDetailsObj,
  workBankDetailsValidator
} from "../../../../../form-control/registration-form/work-bank-details-form-control";

const WorkBankDetails = ({context, controls}) => {
  //Unpack trade form main context
  const { registrationFormState, setRegistrationFormState } = context;
  const { next, back } = controls;
  const [ incomeSourcesState, setIncomeSourcesState ] = useState({
    business: false,
    savings: false,
    inheritance: false,
    donation: false
  });

  //Setup validator and transfer instruction state
  const workBankDetailsState = useValidation(
    workBankDetailsValidator,
    workBankDetailsObj(registrationFormState),
    {border: '1px solid red'});
  const { validate, getTextFieldProps, getDropdownProps, getRadioButtonProps } = workBankDetailsState;

  const nextPage = () => {
    const { formState, isFormValid } = validate();
    const incomeSources = Object.entries(incomeSourcesState)
      .filter(f => f[1])
      .map(f => f[0]);
    console.log(formState, isFormValid, incomeSources);
    if(isFormValid){
      const workBankDetails = {
        accountNumber: formState.accountNumber,
        bankBranch: formState.bankBranch,
        bankName: formState.bankName,
        nature: formState.nature,
        primaryContact: {
          salutation: formState.primaryContactSalutation,
          lastName: formState.primaryContactLastName,
          firstName: formState.primaryContactFirstName,
          middleName: formState.primaryContactMiddleName
        },
        primaryContactEmailAddress: formState.primaryContactEmailAddress,
        primaryContactTelNo: formState.primaryContactTelNo,
        taxStatus: formState.taxStatus,
        tin: formState.tin,
        incomeSource: incomeSources
      }
      setRegistrationFormState({
        ...registrationFormState,
        ...workBankDetails
      });
      next();
    }
  }

  const getIncomeSources = () => {
    return [
      {'key': 'business', 'value': 'Business'},
      {'key': 'savings', 'value': 'Savings'},
      {'key': 'inheritance', 'value': 'Inheritance'},
      {'key': 'donation', 'value': 'Donation'}
    ]
  }

  const incomeSourcesChange = key => {
    setIncomeSourcesState({
      ...incomeSourcesState,
      [key]: !incomeSourcesState[key]
    })
  }

  return (
    <div className={styles['form-section']} >
      <Row>
        <Col lg={12}>
          <FormGroup header={'PRIMARY CONTACT INFORMATION'}>
            <Row>
              <Col lg={5}>
                <RadioButton inputProps={getRadioButtonProps('primaryContactSalutation')}
                             data={getGenericSalutationTypes()} othersOption={false}>
                  Salutation:*
                </RadioButton>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div>
                  Name:*
                </div>
              </Col>
              <Col lg={3}>
                <TextInput inputProps={getTextFieldProps('primaryContactLastName')} placeholder={"Last Name"}>
                </TextInput>
              </Col>
              <Col lg={3}>
                <TextInput inputProps={getTextFieldProps('primaryContactFirstName')} placeholder={"First Name"}>
                </TextInput>
              </Col>
              <Col lg={3}>
                <TextInput inputProps={getTextFieldProps('primaryContactMiddleName')} placeholder={"Middle Initial"}>
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('primaryContactTelNo')} placeholder={""}>
                  Telephone Number:*
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('primaryContactEmailAddress')} placeholder={""}>
                  Email Address:*
                </TextInput>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup header={'WORK/BUSINESS DETAILS'}>
            <Row>
              <Col lg={7}>
                <TextInput inputProps={getTextFieldProps('nature')} placeholder={""}>
                  Occupation/Nature of Business:*
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div>
                  Sources on Income:*
                </div>
              </Col>
              <Col lg={5}>
                {
                  getIncomeSources().map(f => {
                    return <div className={styles['source-income-checkbox']}><input type="checkbox" onChange={()=> incomeSourcesChange(f.key)} />{' '}{f.value}</div>
                  })
                }
              </Col>
            </Row>
          </FormGroup>
          <FormGroup header={'TAX DETAILS'}>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('tin')} placeholder={""}>
                  Tax Identification Number:*
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <RadioButton inputProps={getRadioButtonProps('taxStatus')}
                             data={getTaxStatusTypes()} othersOption={true}>
                  Tax Status:*
                </RadioButton>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup header={'SETTLEMENT BANK DETAILS'}>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('accountNumber')} placeholder={""}>
                  Current/Savings Account Number:*
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <DropDown inputProps={getDropdownProps('bankName')} values={getSettBankList()}>
                  Bank Name:*
                </DropDown>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('bankBranch')} placeholder={""}>
                  Bank Branch:*
                </TextInput>
              </Col>
            </Row>
          </FormGroup>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col xs={6} lg={6}>
          <div className={styles['back-button']}>
            <Button variant="secondary" onClick={() => back()}>
              BACK
            </Button>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['next-button']}>
            <Button onClick={() => nextPage()}>
              NEXT
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default WorkBankDetails;
